
import { defineComponent } from "vue";

export default defineComponent({
  name: "InstructionsPopup4",
  data: () => ({
    showModal: false
  }),
  methods: {
    playGame() {
      window.showOrHideInstructionPopup4(false);
      window.resumeGame();
    },
    handleKeypress(event: KeyboardEvent) {
      if (event.code === 'Escape') {
        this.playGame()
      }
    },
    showPopup(show: boolean) {
      this.showModal = show;
      if (show) {
        document.addEventListener('keydown', this.handleKeypress)
      } else {
        document.removeEventListener('keydown', this.handleKeypress)
      }
    }
  },
  mounted() {
    window.showOrHideInstructionPopup4 = this.showPopup;
  }
});
